export const getCaptionDedupeKey = caption => {
    if (!caption) return null;

    if (caption.id) {
        return String(caption.id);
    }

    if (caption.text) {
        return `${caption.timestamp}:${caption.text}`;
    }

    return null;
};

export const markCaptionAsProcessed = (processedSet, caption) => {
    const key = getCaptionDedupeKey(caption);

    if (!key) {
        return { shouldProcess: false, key: null };
    }

    if (processedSet.has(key)) {
        return { shouldProcess: false, key };
    }

    processedSet.add(key);
    return { shouldProcess: true, key };
};

export const trimProcessedCaptionIds = (processedSet, maxSize = 500) => {
    if (processedSet.size <= maxSize) return;

    const recentEntries = Array.from(processedSet).slice(-Math.floor(maxSize / 2));
    processedSet.clear();
    recentEntries.forEach(entry => processedSet.add(entry));
};
